module.exports = __webpack_public_path__ + "img/port.light.2a6a550e.svg";